// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { Addon } from './addon';
import { AddonBin } from './addon-bin';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonStation extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static TailoringStationId = 1;
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Int32 */
  defaultPriorityOrder!: number;
  /** String(255) */
  name!: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK currentAddonStationId */
  addonBinCurrentAddonStations!: AddonBin[];
  /** Inv FK pendingAddonStationId */
  addonBinPendingAddonStations!: AddonBin[];
  /** Inv FK addonStationId */
  addons!: Addon[];
}

